import { useQuery } from "@apollo/client";

import { useSnackbar } from "./useSnackbar";
import { LOAD_BOOKING_CONTACT_IS_NEW_CUSTOMER } from "../graphql";

function useBookingContactIsNewCustomer(props: { contactId: string }): boolean {
  const { contactId } = props;

  // hooks
  const snackbar = useSnackbar();

  // queries
  const { data, error } = useQuery(LOAD_BOOKING_CONTACT_IS_NEW_CUSTOMER, {
    variables: {
      contactId: contactId,
    },
    skip: !contactId,
    fetchPolicy: "network-only",
  });

  if (error) {
    snackbar.error(error.message);
  }

  return data?.loadBookingContactIsNewCustomer || null;
}

export { useBookingContactIsNewCustomer };
